import { Dispatch } from 'redux';
import { axiosV1 } from 'interceptors/axios';

import { ApiQueryParams } from 'types';

import { decryptResponse } from 'utils/token';
import { dispatchError } from 'utils/dispatchError';

type GetRecipientsByCommunicationProps = {
  communicationId: string;
  params?: ApiQueryParams;
  includeRanges?: boolean;
  signal?: AbortSignal;
};

export const getRecipientsByCommuncation =
  ({
    communicationId,
    params = {},
    signal,
  }: GetRecipientsByCommunicationProps) =>
  async (dispatch: Dispatch) => {
    try {
      const { data } = await axiosV1.get(
        `/comms/recipients/${communicationId}`,
        {
          params,
          // signal,
        }
      );

      const decodedData = await decryptResponse(data);

      return decodedData;
    } catch (error) {
      return dispatchError(error, dispatch);
    }
  };
